<template>
  <require from="framework/html_behaviors/af-items-loader"></require>
  <require from="framework/html_behaviors/af-sort-column"></require>
  <require from="framework/html_behaviors/af-sort-context"></require>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/as-table-skeleton"></require>
  <require from="components/filters/countries-filter"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-widget.html"></require>
  <require from="controls/bs-form-input"></require>

  <as-page-jumbo icon="fas fa-globe-africa fa-fw" heading="Countries & Approvers administration" intro="Add a new country or update existing country's settings and approvers.">
    <div slot="default">
      <as-form-widget>
        <div slot="default">
          <countries-filter model.bind="filter" mutated.call="filterMutated()"></countries-filter>
        </div>
      </as-form-widget>
      <div class="sc-buttons-container">
        <button type="button" class="btn btn-light" af-mutex-click.call="createNewCountry()">
          <i class="fas fa-plus"></i> Create new
        </button>
      </div>
    </div>
  </as-page-jumbo>
  <div class="container-fluid">
    <table class="table table-borderless table-hover sc-table-fixed sc-table-sticky sc-list-highlight" af-sort-context.bind="sortInstruction">
      <thead>
        <tr>
          <th af-sort-column="Name">Name</th>
          <th width="285px" class="d-none d-xl-table-cell" af-sort-column="ApprovalRequirement">Approval</th>
          <th width="225px" class="d-none d-lg-table-cell d-xl-none" af-sort-column="ApprovalRequirement">Approval</th>
          <th width="120px" class="d-none d-sm-table-cell d-lg-none" af-sort-column="ApprovalRequirement">Approval</th>
          <th width="55px" class="d-sm-none" af-sort-column="ApprovalRequirement">Appr.</th>

          <th width="285px" class="d-none d-xl-table-cell" af-sort-column="ApproveType">Approval Category</th>
          <th width="165px" class="d-none d-lg-table-cell d-xl-none" af-sort-column="ApproveType">Approval Category</th>
          <th width="80px" class="d-none d-sm-table-cell d-lg-none" af-sort-column="ApproveType">Catg.</th>
          <th width="55px" class="d-sm-none" af-sort-column="ApproveType">Catg.</th>

          <th width="125px" class="d-none d-lg-table-cell" af-sort-column="ApprovalLevel.Name">Approval Level</th>
          <th width="85px" class="d-md-table-cell d-lg-none" af-sort-column="ApprovalLevel.Name">Level</th>
        </tr>
      </thead>
      <tbody if.bind="loaded">
        <tr class="sc-selectable ${!country.isActive ? 'sc-archived' : ''} ${$index % 2 ? 'sc-row-even' : ''} sc-content-appear" virtual-repeat.for="country of countries" click.delegate="showCountry(country)">
          <td title="${country.name}">
            <div class="d-flex">
              <span innerhtml="${country.flag | sanitizeHTML}" class="d-none d-sm-table-cell" style="margin-right: 5px;"></span>
              <a href="#/${homeRoute & oneTime}/admin/countries/${country.id}" innerhtml="${country.highlightedName | sanitizeHTML}" class="text-truncate sc-content-main"></a>
            </div>
          </td>
          <td class="text-right text-sm-left" title="${country.approvalRequirement.name}">
            <i class="fas fa-fw fa-xs mr-2 ai-country-approval-requirement ${'--requirement-' + country.approvalRequirement.value}"></i>
            <span class="d-none d-lg-inline">${country.approvalRequirement.name}</span>
            <span class="d-none d-sm-inline d-lg-none">${country.approvalRequirement.shortName}</span>
          </td>
          <td class="text-right text-sm-left" title="${country.approveType.name}">
            <i class="fas fa-fw fa-xs mr-2 ai-country-approve-type ${'--type-' + country.approveType.value}"></i>
            <span class="d-none d-lg-inline">${country.approveType.name}</span>
            <span class="d-none d-sm-inline d-lg-none">${country.approveType.shortName}</span>
          </td>
          <td title="${country.approvalLevel.name}">${country.approvalLevel.name}</td>
        </tr>
      </tbody>
      <tbody as-element="as-table-skeleton" else></tbody>
    </table>
    <div class="sc-table-norows" if.bind="countries.length === 0">No items found</div>
    <af-items-loader items.bind="countries" fetch.call="fetchCountries(skip, take)" batch-size.bind="batchSize" template="templates/items-loader.html"></af-items-loader>
  </div>
</template>
